export default __webpack_public_path__ + "static/media/icon_download.0f4ab87d.svg";